import BaseModel from './base/BaseModel.model';
import { ReportEvaluationState } from '@/enums/ReportEvaluationState';

export default class AnalyticalMatrixEvaluation extends BaseModel {

    public description : string | null;
    public porposalUserReportEvaluationId: number | null;
    public especificObjectiveId: number | null;
    public state:ReportEvaluationState = ReportEvaluationState.Pendiente;
    public radioButtonGuidUI : string | null = null;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.porposalUserReportEvaluationId = null;
        this.description = null;
        this.especificObjectiveId = null;
    }
}